export default {
    user : 'user/',
    admin: 'user/admin-users/',
    user_contact_us: 'user/contact-us/',
    product : 'product/',
    design_product_templates : 'product/personal_projects/',
    favorite_product : 'product/favorites/',
    product_cart: 'product/cart/',
    product_template : 'product/product_template/',
    order : 'order/',
    cart : 'product/cart/',
    payment : 'payment/',
    report : 'report/',
    coupon : 'coupon-management/',
    coupoun_uses : 'coupon-management/coupon-uses/',
    coupon_batch: 'coupon-management/coupon-batches/',
    client_endpoints: 'coupon-management/client-coupons/',
};